/* src/app/shared/footer/footer.component.scss */
.footer {
  padding: 0px;
  margin: 0px;
  background-color: #5F96BA;
  z-index: 500;
}
.footer-container {
  display: flex;
  flex-direction: row;
  height: 165px;
  padding: 50px;
}
.footer-copyright {
  flex: 1;
  font-size: 13px;
  color: #FFF;
}
.footer-icon {
  width: 18px;
  height: 18px;
  margin: 5px;
}
.footer-lg {
  font-family: "Gotham-Bold", serif;
  color: #FFF;
  font-size: 22px;
}
.footer-sm {
  font-family: "Lato-Regular", serif;
  color: #FFF;
  font-size: 18px;
}
.footer-link {
  color: inherit;
  text-decoration: none;
}
.footer-link:hover {
  text-decoration: none;
}
@media screen and (max-width: 1000px) {
  .footer-container {
    flex-direction: column;
    height: auto;
  }
  .footer-sm {
    font-size: 16px;
  }
  .footer-lg {
    font-size: 20px;
  }
  .about-us {
    margin-top: 40px;
  }
}
/*# sourceMappingURL=footer.component.css.map */
